import React from 'react';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { UiInput } from './ui';

/**
 * ช่องกรอก "ห้องแนบสลิป" (Telegram forum topic id) — ใช้ร่วมหน้า Telegram Settings ของร้าน และฟอร์มแก้ไขร้านฝั่งแอดมิน
 * ห่อ UiInput (component กลาง) เพื่อให้หน้าตาเหมือนช่องอื่นทุกหน้า + dark mode ได้เอง — หน้าที่ใช้แตะแค่บรรทัดเดียว
 * (ดู go2pay_backend/docs/telegram-topics/)
 *
 * - ว่าง = ไม่จำกัดห้อง (บอทรับสลิปจากทุกห้องเหมือนเดิม)
 * - supported=false (tenant ยังไม่ลง migration 023) → ไม่แสดงอะไรเลย และหน้าที่ใช้ต้องไม่ส่ง key นี้ไป backend
 */
export interface TelegramTopicFieldProps {
  value: string;
  onChange: (value: string) => void;
  supported?: boolean;
  disabled?: boolean;
  label?: string;
  hint?: string;
  placeholder?: string;
  /** class ของกล่องครอบ (เช่น col-span ใน grid ของฟอร์มแอดมิน) */
  wrapperClassName?: string;
  id?: string;
}

const DEFAULT_LABEL = 'ห้องแนบสลิป (Topic ID)';
const DEFAULT_HINT = 'เฉพาะกลุ่มที่เปิด Topics — พิมพ์ /getid ในห้องที่ต้องการให้บอทรับสลิป แล้วนำ Topic ID มาใส่ · เว้นว่าง = รับสลิปจากทุกห้อง';
const DEFAULT_PLACEHOLDER = 'เว้นว่าง = รับทุกห้อง';

const TelegramTopicField: React.FC<TelegramTopicFieldProps> = ({
  value,
  onChange,
  supported = true,
  disabled = false,
  label = DEFAULT_LABEL,
  hint = DEFAULT_HINT,
  placeholder = DEFAULT_PLACEHOLDER,
  wrapperClassName,
  id = 'telegram_topic_slip_id',
}) => {
  if (!supported) return null;

  return (
    <UiInput
      id={id}
      label={label}
      icon={faHashtag}
      hint={hint}
      wrapperClassName={wrapperClassName}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      // รับเฉพาะตัวเลข — Topic ID เป็นจำนวนเต็มบวกเสมอ
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
    />
  );
};

export default TelegramTopicField;
